import { useState, FormEvent } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { DumbbellIcon } from '@/components/Icons';
import LoadingSpinner from '@/components/LoadingSpinner';

export default function LoginPage() {
  const { login } = useAuth();
  const [loginValue, setLoginValue] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(loginValue, password);

    if (!result.success) {
      setError(result.error || 'Ошибка входа');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-gradient-to-b from-primary-50 to-white">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-600 mb-4">
            <DumbbellIcon className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">GymLab</h1>
          <p className="text-gray-600 mt-1">Отслеживай свой прогресс</p>
        </div>

        <div className="card">
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {error && (
              <div className="p-3 text-sm text-red-700 bg-red-50 rounded-lg">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="login" className="label">
                Логин
              </label>
              <input
                id="login"
                type="text"
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                className="input"
                placeholder="Введите логин"
                autoComplete="username"
                autoCapitalize="none"
                required
              />
            </div>

            <div>
              <label htmlFor="password" className="label">
                Пароль
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                placeholder="Введите пароль"
                autoComplete="current-password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
            >
              {loading ? <LoadingSpinner size="sm" className="text-white" /> : 'Войти'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
